var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnnualReview = function SvgAnnualReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M1.1 14h2v-.6l5-5 4 4 6-6V10h2V3h-7v2h3.6l-4.6 4.6-4-4-5 5V2h18v12h2V2c0-1.1-.9-2-2-2h-18c-1.1 0-2 .9-2 2zM24.1 18v-3h-10v1h-4v-1H.1v3c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2m-22 0v-1h7v1zm13-1h7v1h-7z"
  })));
};
export default SvgAnnualReview;